import moment from "moment";

/**
 * Returns status color and dictionary key for the "confirm data" dot.
 *  green  → confirmed < 1 month ago
 *  yellow → confirmed 1–3 months ago
 *  red    → confirmed > 3 months ago OR never
 */
export const CONFIRM_COLORS = {
  green:  "#22c55e",
  yellow: "#f59e0b",
  red:    "#ef4444",
};

export const CONFIRM_DICT_KEYS = {
  green:  "confirmStatusGreen",
  yellow: "confirmStatusYellow",
  red:    "confirmStatusRed",
};

export function getConfirmStatus(isMapdotConfirmed) {
  if (!isMapdotConfirmed) return "red";
  const diff = moment().diff(moment(isMapdotConfirmed, "YYYY-MM-DD"), "months", true);
  if (diff < 1) return "green";
  if (diff < 3) return "yellow";
  return "red";
}
